module.exports = "/img/_/_/_/assets/images/card/type//health.png?2eb0f42a9ddce54585f7c4ee6b59c7d1";